/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useEffect, useMemo } from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import useRouteName from "../../hooks/useRouteName";
import { Header as WebShellHeader } from "@bookingcom/web-shell";
import { BookingComLogoDarkBackgroundsMono } from "@bookingcom/bui-assets-react/brand";
import useUserAgent from "../../hooks/useUserAgent";
import styles from "./Header.module.css";
import { useLocation } from "react-router-dom";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import flights_currency_selection_with_pos_switch, {
  useTrackCurrencySelectionWithPosSwitch
} from "../../utils/experiments/pricing/flights_currency_selection_with_pos_switch";
import { mcn } from "../../utils/mergeClassnames";
import { RouteName } from "@flights/constants";
import useGlobalContext from "../../hooks/useGlobalContext";

const SMALL_HEADER_PAGE_LIST: RouteName[] = [
  "checkout-fare",
  "checkout-seat-selection",
  "checkout-sirf",
  "checkout-start",
  "checkout-ticket-type",
  "checkout-pax",
  "checkout-extras",
  "checkout-ryanair-confirmation",
  "checkout-payment",
  "checkout-collection", // FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE
  "pb-checkout-payment",
  "messenger",
  "messenger-ended"
];

// flights_currency_selection_with_pos_switch
const ALLOW_CURRENCY_PICKER_PAGE_LIST: RouteName[] = [
  "home",
  "searchresults",
  "searchresults-outbound",
  "searchresults-inbound",
  "fly-anywhere"
];

function HeaderFallback() {
  return <WebShellHeader logo={<BookingComLogoDarkBackgroundsMono />} />;
}

export default function Header() {
  const location = useLocation();
  const routeName = useRouteName();
  const { isMobile } = useUserAgent();
  const { isWebview } = useUserAgent();
  const { features } = useGlobalContext();
  const { trackCurrencySelectionWithPosSwitch } = useTrackCurrencySelectionWithPosSwitch(); // flights_currency_selection_with_pos_switch

  const remoteHeader = useRemoteComponent(
    {
      project: "web-shell",
      service: "header-mfe",
      path: "/TravellerHeader/Flights",
      type: "capla"
    },
    {
      fallbackComponent: HeaderFallback
    }
  );

  const remoteHeaderWithCurrencySelection = useRemoteComponent(
    {
      project: "web-shell",
      service: "header-mfe",
      path: "/TravellerHeader/Flights/Currency",
      type: "capla"
    },
    {
      fallbackComponent: HeaderFallback
    }
  );

  const shouldRenderHeader = useMemo(
    () =>
      !(
        routeName === "not-available" ||
        (isWebview && routeName.includes("checkout-pax")) ||
        (isMobile && routeName.includes("flightdetails")) ||
        (isWebview && routeName === "additional-flights-terms") ||
        (isWebview && routeName === "home") ||
        (isWebview && routeName === "confirmation") ||
        (isWebview && routeName === "pb-order-details") ||
        (isWebview && routeName === "pb-flight-details") ||
        (isWebview && routeName === "pb-add-baggage") ||
        (isWebview && routeName === "pb-cancel-order") ||
        (isWebview && routeName === "pb-cancel-order") ||
        (isWebview && routeName === "pb-checkout-payment") ||
        (isWebview && routeName === "pb-checkout-confirmation") ||
        (isWebview && routeName === "additional-flights-terms")
      ),
    [isWebview, isMobile, routeName]
  );

  // flights_currency_selection_with_pos_switch -- start
  useEffect(() => {
    // Exclude mdot from flights_apps_currency_selection_with_pos_switch stage tracking
    const excludeMdot = features["FLIGHTS_PRICING_EXCLUDE_MDOT_FOR_CURRENCY_SELECTION"] && isMobile;
    if (shouldRenderHeader && !excludeMdot) {
      flights_currency_selection_with_pos_switch.stages.visitors_see_flights_header();
    }
  }, [shouldRenderHeader, isMobile, features]);
  // flights_currency_selection_with_pos_switch -- end

  useEffect(() => {
    if (!isFeatureRunningClientSide("FLIGHTS_WEB_REMOTE_COMPONENT_REDIRECT_AFTER_LOGIN")) return;

    const headerElement = document.querySelector(".web-shell-header-mfe");

    if (!headerElement) return;

    headerElement.dispatchEvent(new Event("shell__navigate"));
  }, [location.pathname, location.search]);

  if (!shouldRenderHeader) {
    return <></>;
  }

  const hideProductsBar = SMALL_HEADER_PAGE_LIST.includes(routeName) || (isMobile && routeName === "searchresults");
  const hideCurrencyPicker = !ALLOW_CURRENCY_PICKER_PAGE_LIST.includes(routeName); // flights_currency_selection_with_pos_switch

  const { Component } = remoteHeader;
  const { Component: ComponentWithCurrencySelection } = remoteHeaderWithCurrencySelection; // eslint-disable-line @typescript-eslint/naming-convention
  return (
    <div
      className={mcn(
        hideProductsBar ? styles.hideProductsBar : "",
        hideCurrencyPicker ? styles.hideCurrencyPicker : "" // flights_currency_selection_with_pos_switch
      )}
    >
      {trackCurrencySelectionWithPosSwitch() ? <ComponentWithCurrencySelection /> : <Component />}
    </div>
  );
}
